import React from 'react'
import { useTranslation } from 'next-i18next'

type DpeScoreProps = {
  score: number
}

export default function DpeScore({ score }: DpeScoreProps) {
  const { t } = useTranslation('originals/property')

  const DpeComponent = (globalScore: number) => {
    if (globalScore <= 69) {
      return (
        <div className="flex h-7 w-7 items-center rounded-lg bg-green-700">
          <div className="mx-auto font-bold text-white">A</div>
        </div>
      )
    }

    if (globalScore >= 70 && globalScore <= 109) {
      return (
        <div className="flex h-7 w-7 items-center rounded-lg bg-green-600">
          <div className="mx-auto font-bold text-white">B</div>
        </div>
      )
    }

    if (globalScore >= 110 && globalScore <= 179) {
      return (
        <div className="flex h-7 w-7 items-center rounded-lg bg-amber-300">
          <div className="mx-auto font-bold text-white">C</div>
        </div>
      )
    }

    if (globalScore >= 180 && globalScore <= 249) {
      return (
        <div className="flex h-7 w-7 items-center rounded-lg bg-amber-500">
          <div className="mx-auto font-bold text-white">D</div>
        </div>
      )
    }

    if (globalScore >= 250 && globalScore <= 329) {
      return (
        <div className="flex h-7 w-7 items-center rounded-lg bg-amber-600">
          <div className="mx-auto font-bold text-white">E</div>
        </div>
      )
    }

    if (globalScore >= 330 && globalScore <= 419) {
      return (
        <div className="flex h-7 w-7 items-center rounded-lg bg-amber-700">
          <div className="mx-auto font-bold text-white">F</div>
        </div>
      )
    }

    if (globalScore >= 420) {
      return (
        <div className="flex h-7 w-7 items-center rounded-lg bg-red-700">
          <div className="mx-auto font-bold text-white">G</div>
        </div>
      )
    }

    return <></>
  }

  return (
    <div className="flex items-center">
      {DpeComponent(score)}
      <div className="ml-2 flex items-center">
        <div className="font-bold text-neutralBlack">{score}</div>
        <div className="ml-1 text-xs font-thin text-neutralBlack">
          {t('dpeAndWorkSection.dpe.kWhEP')}
        </div>
      </div>
    </div>
  )
}
